import React from "react";
import TimeAgo from "react-timeago";

const StaffTypeList = ({ items, onEdit }) => {
	if (items && items.length < 1)
		return (
			<div className="text-center">
				<h5>No Staff type has been added yet</h5>
			</div>
		);
	return (
		<div className="inbox-body no-pad table-responsive">
			<table className="table table-inbox table-hover table-bordered">
				<thead>
					<tr>
						<th className="text-center">SN</th>
						<th>Name</th>
						<th>Created</th>
						<th className="text-center">Action</th>
					</tr>
				</thead>
				<tbody>
					{items &&
						items.map((type, index) => (
							<tr key={index}>
								<td className="inbox-small-cells text-center">
									{index + 1}
								</td>
								<td className="view-message">
									<h5>{type.name}</h5>
								</td>
								<td className="view-message">
									<TimeAgo
										date={new Date(
											parseInt(type.created_at)
										).toLocaleDateString()}
									></TimeAgo>
								</td>
								<td className="view-message text-center">
									<button
										onClick={() => onEdit(type)}
										className="mdl-button mdl-button--icon mdl-button--colored btn-default"
									>
										<i className="material-icons text-success">
											edit
										</i>
									</button>
								</td>
							</tr>
						))}
				</tbody>
			</table>
		</div>
	);
};

export default StaffTypeList;
